<app-stale-bundle-banner></app-stale-bundle-banner>
<router-outlet></router-outlet>
<weave-loading-overlay></weave-loading-overlay>
